/**
 * Allowlist/blocklist for Microsoft Clarity.
 *
 * Clarity must NEVER load, initialise, or record on private/authenticated
 * routes (admin, account, auth, checkout, assessment results, etc.). We use
 * an explicit allowlist of public marketing/content routes and a hard
 * blocklist as defence-in-depth.
 */

// Hard blocklist - never allow Clarity here, even if it looks public.
const BLOCKED_PREFIXES = [
  "/admin",
  "/account",
  "/auth",
  "/login",
  "/signup",
  "/checkout",
  "/saved-careers",
  "/my-path",
  "/blueprint",
  "/results",
  "/refined-results",
  "/career-matches",
  "/assessment",
  "/verify",
  "/reset-password",
  "/unsubscribe",
];

// Allowlist of public, non-personal routes. Anything not matching here is
// treated as private by default.
const ALLOWED_EXACT = new Set<string>([
  "/",
  "/how-it-works",
  "/pricing",
  "/faq",
  "/contact",
  "/reviews",
  "/blog",
  "/careers",
  "/explore",
  "/cookie-policy",
  "/privacy",
  "/terms",
  "/refund-policy",
  "/accelerator",
]);

const ALLOWED_PREFIXES = [
  "/blog/",
  "/careers/",
  "/career/",
  "/quiz/",
];

function normalise(pathname: string): string {
  if (!pathname) return "/";
  // Strip trailing slash (except root) to normalise comparisons.
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }
  return pathname;
}

export function isClarityAllowedPath(pathname: string): boolean {
  const p = normalise(pathname).toLowerCase();

  // Hard block first.
  for (const prefix of BLOCKED_PREFIXES) {
    if (p === prefix || p.startsWith(prefix + "/")) return false;
  }

  if (ALLOWED_EXACT.has(p)) return true;
  for (const prefix of ALLOWED_PREFIXES) {
    if ((p + "/").startsWith(prefix)) return true;
  }
  return false;
}
